// extracted by mini-css-extract-plugin
module.exports = {"on":"ChartToggler_on_3xpk3","off":"ChartToggler_off_z0lVF"};